import React, { useEffect, useState } from 'react'
import { ShowBasketCartList, DeleteBasketCartItem, Addbasketsubscriptionaddtocartdata } from '../../../Services/UserService/clientService';
import Content from '../../../components/Contents/Content';
import { NotepadText } from 'lucide-react';
import showCustomAlert from '../../../Extracomponents/CustomAlert/CustomAlert';
import { loadScript } from '../../../../Utils/Razorpayment';
import { basicsettinglist } from "../../../Services/Admin/Admin";
import ReusableModal from '../../../components/Models/ReusableModal';
import ReusableModal1 from '../../../components/Models/ReusableModal1';
import Kyc from '../Profile/Kyc';
import { GetUserData } from '../../../Services/UserService/User';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../../Utils/Loader';

const BasketCart = () => {

    const token = localStorage.getItem('token');
    const userid = localStorage.getItem('id');

    const navigate = useNavigate();

    const [cartItems, setCartItems] = useState([]);
    const [finalPrice, setFinalPrice] = useState(0);
    const [getkey, setGetkey] = useState([]);
    const [company, setCompany] = useState([]);
    const [allKey, setAllKey] = useState([])
    const [kycStatus, setKycStatus] = useState("")
    const [userdata, setUserdata] = useState([]);
    const [viewmodel2, setViewModel2] = useState(false);
    const [viewmodel3, setViewModel3] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [kyckey, setKyckey] = useState([])
    const [dataLoaded, setDataLoaded] = useState(false);

    const fullUrl = window.location.href
    const hashPart = window.location.hash;
    const queryString = hashPart.includes('?') ? hashPart.split("?").slice(1).join("&") : '';
    const searchParams = new URLSearchParams(queryString);
    const urlPlanId = searchParams.get("planid");

    // Function to remove planid from URL (for hash routing)
    const removePlanIdFromUrl = () => {
        const currentHash = window.location.hash;
        if (currentHash.includes('?')) {
            const [hashPath, queryPart] = currentHash.split('?');
            const params = new URLSearchParams(queryPart);
            params.delete('planid');

            // If there are other parameters, keep them
            const newQuery = params.toString();
            const newHash = newQuery ? `${hashPath}?${newQuery}` : hashPath;

            window.location.hash = newHash;
        }
    };

    const handleShowModal = (item) => {

 if (!userdata?.Email) {
        showCustomAlert("error", "Please Complete The Profile");
        return;
      }
        
        if (kycStatus == 1 && (userdata?.kyc_verification == 0 || userdata?.kyc_verification == 2)) {
            setViewModel2(true)
            setKyckey(item[0]?._id)
        } else {
            AddBasketSubscribeAddToCart(item)
        }
    };

    const fetchUserData = async () => {
        try {
            const userData = await GetUserData(userid, token);
            if (userData && userData.data) {
                setUserdata(userData.data)
            }
        } catch (error) {
            showCustomAlert("error", "Failed to load user data. Please refresh and try again.");
        }
    }

    const getkeybydata = async () => {
        try {
            const response = await basicsettinglist();
            if (response.status) {
                setGetkey(response?.data[0]?.razorpay_key);
                setCompany(response?.data[0]?.from_name);
                setAllKey(response.data[0])
                setKycStatus(response?.data[0].kyc)
            }
        } catch (error) {
            console.error("Error fetching coupons:", error);
        }
    };

    const basketList = async () => {
        try {
            const response = await ShowBasketCartList(userid, token);
            if (response.status) {
                setCartItems(response.data);
            } else {
                setCartItems([])
            }
        } catch (err) {
            console.log('Error fetching cart:', err);
        }
    };

    useEffect(() => {
        const loadData = async () => {
            await basketList();
            await getkeybydata();
            await fetchUserData();
            setDataLoaded(true);
        };
        loadData();
    }, []);

    // Auto-trigger Razorpay when planid is present and data is loaded
    useEffect(() => {
        if (urlPlanId && dataLoaded && cartItems.length > 0 && finalPrice > 0) {
            // Small delay to ensure everything is properly loaded
            setTimeout(() => {
                handleShowModal(cartItems);
            }, 500);
        }
    }, [urlPlanId, dataLoaded, cartItems, finalPrice]);

    const handleDelete = async (item) => {
        try {
            const confirmed = await showCustomAlert(
                "confirm",
                "Do you want to remove this item? This action cannot be undone."
            );

            if (!confirmed.isConfirmed) return;

            const data = {
                client_id: userid,
                id: item?._id,
            };

            const response = await DeleteBasketCartItem(data, token);

            if (response.status) {
                showCustomAlert("Success", response.message);
                basketList();
            }
        } catch (error) {
            showCustomAlert("error", "There was an error deleting the cart.");
        }
    };

    const AddBasketSubscribeAddToCart = async (item) => {
        try {
            if (!window.Razorpay) {
                await loadScript("https://checkout.razorpay.com/v1/checkout.js")
            }

            const Price = Math.round(finalPrice * 100);

            const options = {
                key: getkey,
                amount: Price,
                name: company,
                currency: "INR",
                handler: async function (response1) {
                    setIsLoading(true);

                    // Remove planid from URL when payment is successful
                    if (urlPlanId) {
                        removePlanIdFromUrl();
                    }

                    const data = {
                        basket_ids: item.map(items => items?.basket_id?._id).filter(id => id),
                        client_id: userid,
                        coupon: 0,
                        orderid: response1?.razorpay_payment_id,
                        discount: 0,
                        price: Price,
                    };

                    try {
                        const response2 = await Addbasketsubscriptionaddtocartdata(data, token);
                        setIsLoading(false);

                        if (response2?.status) {
                            if (kycStatus == 2 && userdata?.kyc_verification == 0) {
                                setViewModel3(true);
                            } else {
                                navigate("/user/thankyou", {
                                    state: {
                                        planType: data,
                                    },
                                });
                            }
                        }
                    } catch (error) {
                        console.error("Error while adding plan subscription:", error);
                        setIsLoading(false);
                    }
                },
                modal: {
                    ondismiss: function () {
                        // Remove planid from URL when Razorpay is dismissed/closed
                        if (urlPlanId) {
                            removePlanIdFromUrl();
                        }
                    }
                },
                prefill: {},
                theme: {
                    color: "#F37254",
                }
            };

            const rzp = new window.Razorpay(options);
            rzp.open();

            // Fallback: Remove planid if razorpay fails to open
            rzp.on('payment.failed', function (response) {
                if (urlPlanId) {
                    removePlanIdFromUrl();
                }
            });

        } catch (error) {
            console.error("Subscription error:", error);
            // Remove planid from URL on error as well
            if (urlPlanId) {
                removePlanIdFromUrl();
            }
        }
    }

    const totalPrice = cartItems?.reduce((sum, item) => sum + (item.basket_id?.basket_price || 0), 0);
    const gstAmount = (totalPrice / 100) * 18
    const finalAmount = totalPrice + gstAmount;

    useEffect(() => {
        setFinalPrice(finalAmount);
    }, [cartItems]);

    if (isLoading) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: '100vh' }}>
                <Loader />
            </div>
        );
    }

    return (
        <Content Page_title="Basket Cart"
            backbutton_status={true}
            button_status={false}
            backbutton_title="Back">
            <div className="container mt-4">

                {cartItems.length > 0 && (
                    <div className="container" style={{ maxHeight: "35vh", overflowY: "auto" }}>
                        {cartItems?.map((item, index) => (
                            <div key={index} className="card p-3 mb-3 shadow-sm position-relative">
                                <button
                                    className="btn btn-danger position-absolute"
                                    style={{
                                        top: "0px",
                                        right: "-2px",
                                        borderRadius: "15%",
                                        width: "40px",
                                        height: "30px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                    onClick={() => handleDelete(item)}
                                >
                                    <i className="bi bi-trash" style={{ fontSize: "18px" }}></i>
                                </button>

                                <div className="d-flex align-items-center">
                                    <div className="d-flex justify-content-center align-items-center bg-success rounded-circle" style={{ width: "70px", height: "70px" }}>
                                        <NotepadText size={40} style={{ color: "white" }} />
                                    </div>

                                    <div className="ms-3">
                                        <h5 className="mb-1"><b>{item.basket_id?.title || 'No Title'}</b></h5>
                                        <p className="mb-1" style={{ color: "#a6a6a6" }}>{item.basket_id?.themename || 'No Validity'}</p>
                                        <p className="fw-bold" style={{ color: "#00e600" }}>₹{item.basket_id?.basket_price?.toLocaleString() || 'No Price'}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {cartItems.length === 0 ? (
                    <div className="text-center mt-5">
                        <img
                            src="/assets/images/nodata.png"
                            alt="No Records Found"
                            style={{ maxWidth: "300px" }}
                        />
                    </div>
                ) : (
                    <div className="container">
                        <h4 className="mt-4 text-light"><b>Plan Summary</b></h4>
                        <div className="card mt-0" style={{ border: "1px solid primary" }}>
                            <div className="card-body text-light">
                                <div className="d-flex justify-content-between">
                                    <strong>Total:</strong> <span className="fs-5">₹{totalPrice.toLocaleString()}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <strong>GST (18%):</strong> <span>₹{gstAmount.toLocaleString()}</span>
                                </div>
                                <hr />
                                <div className="d-flex justify-content-between fw-bold fs-5">
                                    <strong>Grand Total:</strong> <span>₹{(totalPrice + gstAmount).toLocaleString()}</span>
                                </div>
                                <div className="text-center mt-3">
                                    <button className="btn btn-primary w-100 fw-bold"
                                        onClick={() => handleShowModal(cartItems)}
                                    >
                                        Buy Now
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <ReusableModal
                show={viewmodel2}
                onClose={() => setViewModel2(false)}
                title={<>KYC</>}
                body={
                    <Kyc
                        onSuccess={() => {
                            setViewModel2(false);
                        }}
                        type="basketcart"
                        kyckey={kyckey}
                    />
                }
                size="lg"
            />

            <ReusableModal1
                show={viewmodel3}
                onClose={() => setViewModel3(false)}
                title={<>KYC</>}
                body={
                    <Kyc
                        onSuccess={() => {
                            setViewModel3(false);
                        }}
                        type="basketcart"
                    />
                }
                disableClose={false}
                size="lg"
            />
        </Content>
    )
};

export default BasketCart;